import { toastr } from 'react-redux-toastr'

import { errorsAlert } from 'helpers/applicationHelper'

import * as types from './actionTypes'

export const fetchResignationApprovalsSuccess = (payload) => ({
  type: types.FETCH_RESIGNATION_APPROVALS_SUCCESS,
  payload
})

export const fetchResignationApprovalsFailure = (payload) => {
  errorsAlert(payload, 'Failed to fetch Approvals!')
}

export const updateResignationApprovalsSuccess = (payload) => (dispatch) => {
  dispatch({
    type: types.UPDATE_RESIGNATION_APPROVALS_SUCCESS,
    payload
  })
  toastr.success('Approver replaced successfully!')
}

export const updateResignationApprovalsFailure = (payload) => {
  errorsAlert(payload, 'Failed to update Approvals!')
}

export const createResignationApprovalStatusSuccess = (payload) => (dispatch) => {
  dispatch({
    type: types.CREATE_RESIGNATION_APPROVAL_STATUS_SUCCESS,
    payload
  })
  toastr.success('Status updated successfully!')
}

export const createResignationApprovalStatusFailure = (payload) => {
  errorsAlert(payload, 'Failed to update Status!')
}

export const submitApprovableFieldResponsesSuccess = () => () => {
  toastr.success('Response submitted successfully!')
}

export const submitApprovableFieldResponsesFailure = (payload) => {
  errorsAlert(payload, 'Failed to submit response!')
}

export const createResignationTimelineSuccess = (payload) => (dispatch) => {
  dispatch({
    type: types.CREATE_RESIGNATION_TIMELINE_SUCCESS,
    payload
  })
  toastr.success('Resignation placed successfully!')
}

export const updateResignationTimelineSuccess = (payload) => (dispatch) => {
  dispatch({
    type: types.UPDATE_RESIGNATION_TIMELINE_SUCCESS,
    payload
  })
  toastr.success('Resignation updated successfully!')
}

export const updateResignationTimelineFailure = (payload) => {
  errorsAlert(payload, 'Failed to update Resignation!')
}

export const createResignationTimelineFailure = (payload) => {
  errorsAlert(payload, 'Failed to place Resignation!')
}

export const fetchUserResignationTimelineSuccess = (payload) => (dispatch) => {
  dispatch({
    type: types.FETCH_USER_RESIGNATION_TIMELINE_SUCCESS,
    payload
  })
}

export const fetchUserResignationTimelineFailure = (payload) => {
  errorsAlert(payload, 'Failed to fetch Resignation Timeline!')
}

export const createResignationRevokeStatusSuccess = (payload) => (dispatch) => {
  dispatch({
    type: types.CREATE_RESIGNATION_REVOKE_STATUS_SUCCESS,
    payload
  })
  toastr.success('Resignation revoked successfully!')
}

export const createResignationRevokeStatusFailure = (payload) => {
  errorsAlert(payload, 'Failed to revoke Resignation!')
}

export const fetchResignationTimelineSuccess = (payload) => (dispatch) => {
  dispatch({
    type: types.FETCH_RESIGNATION_TIMELINE_SUCCESS,
    payload
  })
}

export const fetchResignationTimelineFailure = (payload) => {
  errorsAlert(payload, 'Failed to fetch Resignation Timeline!')
}

export const updateResignationOffboardingDependencySuccess = (payload) => (dispatch) => {
  dispatch({
    type: types.UPDATE_RESIGNATION_OFFBOARDING_DEPENDENCY_SUCCESS,
    payload
  })
  toastr.success('Offboarding Dependency updated successfully!')
}

export const updateResignationOffboardingDependencyFailure = (payload) => {
  errorsAlert(payload, 'Failed to Update Offboarding Dependency!')
}
